<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('common.add') + '  ' + $t('hospital.doctors-assistant')
          : $t('common.edit') + '  ' + $t('hospital.doctors-assistant')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('common.name')" label-for="name">
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('common.name')"
              />
              <p v-if="errorForm.name" class="ml-25 error text-danger">
                This field is required.
              </p>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group :label="$t('common.type')" label-for="type">
              <v-select
                v-model="EditForm.type"
                :placeholder="$t('common.type')"
                :options="[
                  { value: 'surgeon_assistant', label: 'Surgeon Assistant' },
                  {
                    value: 'anesthetist_assistant',
                    label: 'Anesthetist Assistant',
                  },
                ]"
                :reduce="(item) => item.value"
              />
              <p v-if="errorForm.type" class="ml-25 error text-danger">
                This field is required.
              </p>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group :label="$t('common.phone')" label-for="phone">
              <VuePhoneNumberInput
                v-model="EditForm.phone"
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
                default-country-code="IQ"
                :error="
                  EditForm.phone ? isNotValid || EditForm.phone[0] != 0 : false
                "
              />
              <p v-if="errorForm.phone" class="ml-25 error text-danger">
                This field is required.
              </p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{ $t("common.add") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-card :title="$t('hospital.doctors-assistant')">
      <!-- Search Patient Name -->
      <div>
        <b-row>
          <b-col cols="12" md="12">
            <h2>{{ $t("hospital.filter-doctors-assistant") }}</h2>
            <br />
          </b-col>

          <b-col md="4" cols="12">
            <b-form-group :label="$t('clinic.doctors-name')" label-for="Name">
              <b-form-input
                id="Name"
                v-model="doctorName"
                :placeholder="$t('clinic.doctors-name')"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('common.type')" label-for="type">
              <v-select
                v-model="typeFilter"
                :placeholder="$t('common.type')"
                :options="[
                  {
                    value: 'surgeon_assistant',
                    label: this.$t('hospital.surgeon-assistant'),
                  },
                  {
                    value: 'anesthetist_assistant',
                    label: this.$t('hospital.anesthetist-assistant'),
                  },
                ]"
                :reduce="(item) => item.value"
              />
            </b-form-group>
          </b-col>
          <b-col md="4" cols="12">
            <b-form-group :label="$t('clinic.doctors-phone')" label-for="Phone">
              <VuePhoneNumberInput
                v-model="doctorPhone"
                @update="
                  (obj) => {
                    showPhoneObj(obj, 'countryCallingCode');
                  }
                "
                :placeholder="$t('clinic.doctors-phone')"
                default-country-code="IQ"
                :error="doctorPhone ? isNotValid || doctorPhone[0] != 0 : false"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getDoctorAssistant()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("hospital.doctors-assistant") }}</h2>
          <b-button
            variant="primary"
            v-if="$store.state.app.permissions.includes('store-doctor')"
            @click="show(EditForm, 'create')"
          >
            {{ $t("common.add") + "  " + $t("hospital.doctors-assistant") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(type)="data">
            <span
              v-if="data.item.type == 'surgeon_assistant'"
              class="text-success"
            >
              {{ $t("hospital.surgeon-assistant") }}
            </span>
            <span
              v-if="data.item.type == 'anesthetist_assistant'"
              class="text-success"
            >
              {{ $t("hospital.anesthetist-assistant") }}
            </span>
          </template>
          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap d-flex">
              <!-- @click="printId(data.item.id)" -->
              <!-- <b-button
                v-if="$store.state.app.permissions.includes('show-doctor')"
                variant="primary"
                class="mx-1 bgcolor"
                @click="
                  $router.push({
                    name: 'hospital-doctor-preview',
                    params: { id: data.item.id },
                  })
                "
                pill
                size="sm"
              >
                {{ $t("common.preview") }}
              </b-button> -->
              <ActionsButtons
                deletePerm="delete-doctor"
                editPerm="update-doctor"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
              <!-- <b-button
                @click="deleteModel(data.item)"
                pill
                variant="outline-danger"
                v-if="$store.state.app.permissions.includes('delete-doctor')"
                >Delete</b-button
              >
              <b-button
                variant="outline-warning"
                pill
                class="mx-1"
                v-if="$store.state.app.permissions.includes('update-doctor')"
                @click="show(data.item)"
                >Edit</b-button
              > -->
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">Showing 1 to 10 Doctors</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getDoctorAssistant()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BIconSearch,
} from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import permissionChecker from "@/mixins/permissionChecker";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import { formValid } from "@/utils/formValid";
import vSelect from "vue-select";

export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BIconSearch,
    VuePhoneNumberInput,
    ActionsButtons,
    vSelect,
  },
  data() {
    return {
      take: 10,
      loading: true,
      isNotValid: false,
      dataCount: 0,
      doctorName: "",
      doctorPhone: null,
      data: [],
      EditForm: {
        name: "",
        phone: "",
        type: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        phone: "",
        type: "",
      },
      params: {
        form: {},
        path: "",
      },
      tableColumns: [
        { key: "name", sortable: true, label: this.$t("common.name") },
        {
          key: "type",
          sortable: true,
          label: this.$t("common.type"),
          class: "text-nowrap",
        },
        {
          key: "phone",
          sortable: true,
          label: this.$t("clinic.doctors-phone"),
          class: "text-nowrap",
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      searchQuery: "",
      sortBy: "id",
      isSortDirDesc: true,
      page: 1,
      typeFilter: "",
    };
  },
  mounted() {
    this.getDoctorAssistant();
  },
  methods: {
    show(item, mode) {
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          name: "",
          phone: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;

        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.phone = item.phone;
        this.EditForm.type = item.type;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },

    showPhoneObj(obj, countryCallingCodeCheck) {
      this.isNotValid = !obj.isValid;
      countryCallingCodeCheck
        ? (this.countryCallingCodeFirst = obj.countryCallingCode)
        : (this.countryCallingCodeSecond = obj.countryCallingCode);
    },
    async getDoctorAssistant() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/doctorAssistants?page=${this.page}&take=${this.take}&sort=-id`;

      if (this.doctorName) {
        url += `&filter[name]=${this.doctorName}`;
      }
      if (this.doctorPhone) {
        url += `&filter[phone]=${this.doctorPhone}`;
      }
      if (this.typeFilter) {
        url += `&filter[type]=${this.typeFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/doctorAssistants/${this.deleteForm.id}`)
        .then((response) => {
          this.getDoctorAssistant();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.first_name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.first_name,
            },
          });
        });
    },
    submitItem() {
      this.errorForm.phone = "";
      this.errorForm.name = "";
      this.errorForm.type = "";
      let count = 0;
      this.loading = true;
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }
      if (!this.EditForm.phone) {
        count++;
        this.errorForm.phone = "The phone field is required.";
      }
      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }
      if (!this.EditForm.type) {
        count++;
        this.errorForm.type = "The type field is required.";
      }
      if (count > 0) {
        this.loading = false;
        return false;
      }

      console.log(this.EditForm.phone);
      this.EditForm.phone = this.EditForm.phone.replace(/\s+/g, "");
      console.log(this.EditForm);

      if (this.createMode) {
        delete this.EditForm._method;
        (this.params.form = this.EditForm),
          (this.params.path = `/doctorAssistants`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getDoctorAssistant();
              this.$bvModal.hide("modal-edit");
              this.loading = false;
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/doctorAssistants/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getDoctorAssistant();
              this.loading = false;
              this.$bvModal.hide("modal-edit");
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
